export const MAX_ROOM_MEMBERS_COUNT = 4;
